import React from 'react';
import PropTypes from 'prop-types';
import { InventoryEntities } from 'client/data/models/inventory';
import { InventoryHeart } from 'site-modules/shared/components/inventory-heart/inventory-heart';
import { VinHeart } from 'site-modules/shared/components/inventory/vin-heart/vin-heart';
import { ShareButton } from 'site-modules/inventory/components/vdp-actions/share-button/share-button';

export function VdpActions({ vinData = {}, className = '', trackingParent = 'vdp-toolbar', spinnerSize = null }) {
  return (
    <div className="d-flex align-items-center" data-id={vinData.vin} data-tracking-parent={trackingParent}>
      <InventoryHeart vehicle={vinData} spinnerSize={spinnerSize} CustomView={VinHeart} classes={className} />
      <ShareButton vehicle={vinData} />
    </div>
  );
}

VdpActions.propTypes = {
  vinData: InventoryEntities.InventoryVin,
  className: PropTypes.string,
  trackingParent: PropTypes.string,
  spinnerSize: PropTypes.number,
};
